import React, { useState, useEffect, useContext } from "react";
import "./appServices.css";
import image from "../../Assets/AboutImage.png"
import home from "../../Assets/home.png";
import saloon from "../../Assets/saloon.png";
import { useNavigate } from "react-router-dom";
import GenderPopupModel from "../../Components/GenderPopupModel";
import { useTranslation } from "react-i18next";
import { PopupContext } from "../../Context/PopupContext";
import MapViewModal from "../../Components/MapViewModal";

const Services = () => {    
  const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const {
    setIsBranchSelectedFromPopUp,
    setIsBranchSelectedFromNavbar,
  } = useContext(PopupContext);
    const [genderPopupVisibilityPopup ,setGenderPopupVisibilityPopup] = useState(false);
    const [mapPopupVisibility, setMapPopupVisibility] = useState(false)
  return (
    <div className="home_wrapper">
        {
            genderPopupVisibilityPopup && <GenderPopupModel/>
        }
        {
          mapPopupVisibility && <MapViewModal/>
        }
      <section className={"services__jumbotron__Container"}>
       <div className="services__heading">{t("chs_srvc")}</div>
       <div className="top__box__container">
           <span style={{fontWeight:"600"}}>{t("escape_spa")}</span> <br/> {t("two_srvc")}
        </div>
       <div className="services__container">
            <div className="service__card__wrapper" style={{marginRight:"2em"}} onClick={()=>{localStorage.setItem("type", 1); navigate('/home'); setIsBranchSelectedFromPopUp(false);
                setIsBranchSelectedFromNavbar(false); }} >
                <img src={saloon} />
                <div className="service__card__info">
                    <div className="service__card__title">{t("sln_srvc")}</div>
                </div>
            </div>
             <div className="service__card__wrapper" 
                // onClick={()=>{localStorage.setItem("type", 2); navigate('/home'); setIsBranchSelectedFromPopUp(false);
                //     setIsBranchSelectedFromNavbar(false); }}
                onClick={()=>{
                  // setGenderPopupVisibilityPopup(true);
                  setMapPopupVisibility(true) 
                  setIsBranchSelectedFromPopUp(false);
                  setIsBranchSelectedFromNavbar(false);
                }} 
              >
                <img src={home} />
                <div className="service__card__info">
                    <div className="service__card__title">{t("hm_srvc")}</div>
                </div>
            </div>
       </div>
      </section>
    </div>
  );
};

export default Services;
